import { typedFetch, zodValidator } from "~/api/typed-fetch";

import { LogoResponseSchema } from "../schemas";

async function getLogo(signal?: AbortSignal): Promise<string | null> {
  const response = await typedFetch("/admin/logo", {
    validateResponse: zodValidator(LogoResponseSchema),
    signal,
  });

  if (response.logo && response.s3Url) {
    return `${response.s3Url}${response.logo}`;
  }

  return null;
}

export { getLogo };
